import React from "react"
import ModuleCards from "./moduleCards"
const Accounting=()=>{
    return(
        <ModuleCards/>
    )
}

export default Accounting